@if (chatNandaService.isOpen) {
    <div fxLayout="column" class="nanda-chat-accounting-component__gradient">
        <div class="nanda-chat-accounting-component" fxLayout="column" fxFlex>
            <div
                class="nanda-chat-accounting-component__header"
                fxLayout="row"
                fxLayoutAlign="space-between center"
            >
                <div
                    fxLayout="row"
                    class="nanda-chat-accounting-component__header__title gap-12"
                    fxLayoutAlign="start center"
                >
                    <div
                        class="nanda-chat-accounting-component__header__title__icon"
                        fxLayout="column"
                        fxLayoutAlign="center center"
                    >
                        <img
                            src="/images/logos/nanda-icon-logo.svg"
                            width="24px"
                            alt=""
                        />
                    </div>

                    <h1 class="color-text-hint text-16-bold">IA Nanda</h1>
                    <div
                        class="nanda-chat-accounting-component__menu"
                        fxLayout="column"
                        fxLayoutAlign="center center"
                        [matMenuTriggerFor]="menu"
                    >
                        <i class="fa-solid fa-sort-down"></i>
                    </div>

                    <mat-menu #menu="matMenu" class="dsn-menu">
                        <button mat-menu-item (click)="onClearMessages()">
                            <i class="fa-solid fa-trash-can"></i> Apagar
                            Histórico
                        </button>
                    </mat-menu>
                </div>
                <dsn-button-rounded
                    class="button-close-nanda"
                    [type]="'secondary'"
                    [icon]="'fa-solid fa-xmark'"
                    [disabled]="false"
                    [size]="'medium'"
                    (onClick)="onCloseNanda()"
                    [active]="false"
                ></dsn-button-rounded>
            </div>
            <!-- <div
                class="nanda-chat-accounting-component__message padding-8"
                fxLayout="row"
                fxLayoutAlign="center center"
            >
                <p class="text-center color-text-primary text-14-regular">
                    Ferramenta gratuita por tempo <strong>limitado</strong>.
                </p>
            </div> -->
            <div
                class="nanda-chat-accounting-component__section full-height dsn-scrollbar scroll-secondary gap-32 overflow"
                fxLayout="column"
                #messagesWrapper
                [style]="'max-height: auto; min-height: auto'"
            >
                @if (loading) {
                    <div
                        fxLayout="column"
                        fxLayoutAlign="start center"
                        class="gap-16"
                        style="padding-top: var(--spacing-16)"
                        style="
                            background-color: var(--background-color-primary);
                            height: 100%;
                            width: 100%;
                            position: absolute;
                            top: 0px;
                            bottom: 0px;
                            left: 0px;
                            right: 0px;
                            z-index: 1001;
                        "
                    >
                        <div
                            fxLayout="column"
                            class="full-width m-top-16"
                            style="padding: 8px 16px"
                        >
                            @for (i of [1, 2, 3, 4, 5, 6]; track $index) {
                                <div
                                    fxLayout="column"
                                    class="full-width gap-8 m-top-16"
                                    [fxLayoutAlign]="
                                        i % 2 ? 'start start' : 'end end'
                                    "
                                >
                                    <dsn-skeleton-loader
                                        [width]="'220px'"
                                        [height]="'24px'"
                                        [type]="'rectangle'"
                                    ></dsn-skeleton-loader>
                                    <dsn-skeleton-loader
                                        [width]="'180px'"
                                        [height]="'24px'"
                                        [type]="'rectangle'"
                                    ></dsn-skeleton-loader>
                                </div>
                            }
                        </div>
                    </div>
                } @else {
                    <div
                        fxLayout="column"
                        fxLayoutAlign="start none"
                        class="nanda-chat-accounting-component__section__message gap-16"
                    >
                        <div
                            class="nanda-chat-accounting-component__section__message--response text-14-regular color-text-primary gap-16"
                            fxLayout="column"
                            [innerHTML]="initialMessage"
                        ></div>
                        <div
                            class="nanda-chat-accounting-component__section__message__controller gap-8"
                            fxLayout="row"
                            fxLayoutAlign="start none"
                        >
                            <dsn-button-rounded
                                [type]="'quaternary'"
                                [radius]="'medium'"
                                [icon]="'fa-regular fa-clone'"
                                [disabled]="false"
                                [size]="'small'"
                                [active]="false"
                                (onClick)="onCopyMessage(initialMessage)"
                            ></dsn-button-rounded>
                            <dsn-button-rounded
                                [type]="'quaternary'"
                                [radius]="'medium'"
                                [icon]="'fa-solid fa-volume-high'"
                                [disabled]="false"
                                [size]="'small'"
                                [active]="false"
                                (onClick)="onVoiceMessage(initialMessage)"
                            ></dsn-button-rounded>
                        </div>
                    </div>

                    @if (!messagesDatesString.length) {
                        <div
                            class="nanda-chat-accounting-component__section__slash-message gap-16"
                            fxLayout="column"
                            fxLayoutAlign="start start"
                        >
                            <h2 class="text-14-semi-bold color-text-primary">
                                Em que posso te ajudar?
                            </h2>
                            <ul
                                fxLayout="column"
                                class="nanda-chat-accounting-component__section__slash-message__list gap-12"
                            >
                                <li>
                                    <dsn-button
                                        [label]="
                                            'Quais indicadores precisam de atenção?'
                                        "
                                        [type]="'bordered'"
                                        [size]="'medium'"
                                        (onClick)="
                                            onSendMessage(
                                                'Quais indicadores precisam de atenção?'
                                            )
                                        "
                                        [disabled]="typingIndicator"
                                        [iconLeft]="
                                            'fa-regular fa-circle-question'
                                        "
                                        [iconRight]="''"
                                        [active]="false"
                                        [width]="'full'"
                                        [justify]="'start'"
                                        [fontWeight]="'regular'"
                                        [onlyIcon]="''"
                                    ></dsn-button>
                                </li>
                                <li>
                                    <dsn-button
                                        [label]="
                                            'Como melhorar os resultados da empresa?'
                                        "
                                        [type]="'bordered'"
                                        [size]="'medium'"
                                        [disabled]="typingIndicator"
                                        (onClick)="
                                            onSendMessage(
                                                'Como melhorar os resultados da empresa?'
                                            )
                                        "
                                        [iconLeft]="
                                            'fa-regular fa-circle-question'
                                        "
                                        [iconRight]="''"
                                        [active]="false"
                                        [width]="'full'"
                                        [justify]="'start'"
                                        [fontWeight]="'regular'"
                                        [onlyIcon]="''"
                                    ></dsn-button>
                                </li>
                            </ul>
                        </div>
                    }

                    @for (date of messagesDatesString; track $index) {
                        @if (date === "typing-event") {
                            <div class="loading-animation">
                                <span class="loading-bubble"></span>
                                <span class="loading-bubble"></span>
                                <span class="loading-bubble"></span>
                            </div>
                        } @else {
                            <div
                                class="nanda-chat-accounting-component__section__date"
                            >
                                <span
                                    class="nanda-chat-accounting-component__section__date__value"
                                    >{{ date }}</span
                                >
                            </div>
                        }

                        @if (date !== "typing-event") {
                            @for (
                                message of handleGetMessages(date);
                                track $index
                            ) {
                                <div
                                    fxLayout="{{
                                        message.author ? 'row' : 'column'
                                    }}"
                                    fxLayoutAlign="{{
                                        message.author
                                            ? 'end end'
                                            : 'start none'
                                    }}"
                                    class="nanda-chat-accounting-component__section__message {{
                                        message.author && 'author'
                                    }} gap-16"
                                >
                                    @if (message.author) {
                                        <p
                                            class="text-14-regular color-text-primary"
                                        >
                                            {{ message.message }}
                                        </p>
                                    } @else {
                                        <div
                                            fxLayout="column"
                                            class="nanda-chat-accounting-component__section__message--response text-14-regular color-text-primary gap-16"
                                            [innerHTML]="message.message"
                                        ></div>
                                    }
                                    <div
                                        class="nanda-chat-accounting-component__section__message__controller gap-8"
                                        fxLayout="row"
                                        fxLayoutAlign="{{
                                            message.author
                                                ? 'end end'
                                                : 'start none'
                                        }}"
                                    >
                                        @if (message.author) {
                                            <dsn-button-rounded
                                                [type]="'quaternary'"
                                                [radius]="'medium'"
                                                [icon]="'fa-regular fa-clone'"
                                                [disabled]="false"
                                                [size]="'small'"
                                                [active]="false"
                                                (onClick)="
                                                    onCopyMessage(
                                                        message.message
                                                    )
                                                "
                                            ></dsn-button-rounded>
                                        } @else {
                                            <dsn-button-rounded
                                                [type]="'quaternary'"
                                                [radius]="'medium'"
                                                [icon]="'fa-regular fa-clone'"
                                                [disabled]="false"
                                                [size]="'small'"
                                                [active]="false"
                                                (onClick)="
                                                    onCopyMessage(
                                                        message.message
                                                    )
                                                "
                                            ></dsn-button-rounded>
                                            <dsn-button-rounded
                                                (onClick)="
                                                    onVoiceMessage(
                                                        message.message
                                                    )
                                                "
                                                [type]="'quaternary'"
                                                [radius]="'medium'"
                                                [icon]="
                                                    'fa-solid fa-volume-high'
                                                "
                                                [disabled]="false"
                                                [size]="'small'"
                                                [active]="false"
                                            ></dsn-button-rounded>
                                        }
                                    </div>
                                </div>
                            }
                        }
                    }
                }
            </div>
            <form
                class="nanda-chat-accounting-component__footer gap-12"
                fxLayout="column"
                fxLayoutAlign="space-between center"
                [formGroup]="form"
                (ngSubmit)="onSendMessage()"
            >
                <div class="nanda-chat-accounting-component__footer__input">
                    <textarea
                        fxFlex
                        fxLayout="column"
                        formControlName="message"
                        name="message"
                        placeholder="Pergunte qualquer coisa.."
                        class="full-width dsn-scrollbar scroll-secondary {{
                            typingIndicator && 'disabled'
                        }}"
                        required="true"
                        rows="1"
                        (keydown.enter)="onSendMessage()"
                    ></textarea
                    ><dsn-button-rounded
                        [type]="'primary'"
                        [disabled]="form.invalid || typingIndicator"
                        typeButton="submit"
                        [icon]="'fas fa-paper-plane'"
                        [size]="'medium'"
                        [active]="false"
                    ></dsn-button-rounded>
                </div>
                <div fxLayout="column" class="gap-4">
                    <p class="text-12-regular color-text-primary text-center">
                        Conteúdo <strong>gerado por IA</strong>. Confira
                        informações relevantes.
                    </p>
                    <p class="text-12-regular color-text-primary text-center">
                        Ferramenta gratuita por tempo <strong>limitado</strong>.
                    </p>
                </div>
            </form>
        </div>
    </div>
}
